import { useEffect } from 'react';

import { CatalogueState } from '@app/store/catalogue/types';

const getFocusTarget = (element: HTMLElement | null) => {
  if (!element) {
    return null;
  }

  const focusTarget = element.querySelector(
    'a[href], button:not([disabled]), [role="button"], [role="tab"], [tabindex]:not([tabindex="-1"])'
  ) as HTMLElement | null;

  return focusTarget || element;
};

export const useFocusOnLocationChange = (
  catalogue: CatalogueState | null | undefined,
  windowWidth?: number
) => {
  const cataloguePath = catalogue?.paths[catalogue?.paths.length - 1] || '';
  const isCatalogueLoading = catalogue?.isLoading;
  const isCataloguePopular = catalogue?.isPopular;

  const isDesktop = windowWidth && windowWidth >= 1024;

  useEffect(() => {
    if (isCatalogueLoading) {
      return;
    }

    const segments = cataloguePath.split('/').filter(Boolean);
    const categoriesEl = document.querySelector(
      '.mos-catalog_category-scroll--root'
    ) as HTMLElement;
    const subCategoriesEl = document.querySelector(
      '.mos-catalog_category-scroll--level1'
    ) as HTMLElement;
    const servicesEl = document.querySelector(
      '.mos-service-list'
    ) as HTMLElement;

    let targetEl: HTMLElement | null = null;

    if (isDesktop) {
      if (segments.length === 2 && subCategoriesEl) {
        targetEl = getFocusTarget(subCategoriesEl);
      } else if (
        (segments.length === 2 || segments.length === 3) &&
        servicesEl
      ) {
        targetEl = getFocusTarget(servicesEl);
      }
    }

    if (!isDesktop) {
      if (servicesEl) {
        targetEl = getFocusTarget(servicesEl);
      } else if (subCategoriesEl) {
        targetEl = getFocusTarget(subCategoriesEl);
      } else if (categoriesEl) {
        targetEl = getFocusTarget(categoriesEl);
      }
    }

    if (!targetEl) {
      return;
    }

    const focusTarget = () => {
      targetEl?.focus({ preventScroll: true });
    };

    const immediateTimer = window.setTimeout(focusTarget, 0);
    const retryTimer = window.setTimeout(focusTarget, 150);

    return () => {
      window.clearTimeout(immediateTimer);
      window.clearTimeout(retryTimer);
    };
  }, [isDesktop, cataloguePath, isCatalogueLoading, isCataloguePopular]);
};
